import importExport from './import&export.vue'
import moment from 'moment'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$refs['importExport'].importProduct();
    },
    // 导出 --新接口
    onExport() {
      let _this = this
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let columnList = []
      this.columnData.forEach(v=>{
        columnList.push({
          columnName: v.label,
          fieldName: v.prop
        })
      })
      let data = {
        ...this.exportForm,
        exportColumnList: columnList
      } 
      this.$q.productModelDetails.productCycleSaleDetailExport({data: data})
      .then((res) => {
        if(res.message) {
          var timer = setInterval(function() {
              _this.$q.goodsAnalysis
                .filePath({fragment: [res.message]})
                .then(res => {
                  if (res.message) {
                    loading.close();
                    clearInterval(timer);
                    _this.downLoad(res.message, `产品销量明细${moment().format('YYYYMMDDHHmmss')}.xlsx`);
                  }
                })
                .catch(err => {
                  //this.$message(err.message)
                });
            }, 3000);
        }else{
          this.$message.fail(res.message);
        }
      });
    },
    downLoad(url, name) {
      this.downLoadLink(url, name);
    },
    downLoadLink(filePath,fileName) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", filePath, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    }
  }
}